import { useSelector } from "react-redux";
import SearchBusesSection from "./searchBusesSection";
import TicketBooking from "sections/tickingBooking";
import Checkout from "sections/checkout";

function BookTicket() {
  const { activeSection } = useSelector((state) => state.bookingReducer);

  return (
    <>
      {activeSection === "search-buses" ? <SearchBusesSection /> : <Checkout />}
      <TicketBooking />
    </>
  );
}
export default BookTicket;
